import { GRID_FORM_CONFIG_T } from "../../../../common/FormGenerator"
import { CommentInput } from "../../../ui-kit/CommentInput"

export type ReplyBlockName =
  | "replyText"

type GetReplyConfigParams = {
  onSend?: () => void
  disabled?: boolean
}

export const getReplyTextConfig = ({ onSend, disabled }: GetReplyConfigParams = {}) => [
  [
    {
      id: 1,
      controllerName: "replyText",
      RenderElement: CommentInput,
      renderProps: () => ({
        placeholder: "Введите ваш ответ...",
        fullWidth: true,
        autoFocus: true,
        onSend,
        disabled,
        sx: {
          "& .MuiInputBase-root": {
            borderRadius: "12px",
          }
        }
      }),
    },
  ],
]

export const getFormConfig = (blockName: ReplyBlockName, params?: GetReplyConfigParams): GRID_FORM_CONFIG_T<any> => {
  if (blockName === "replyText") {
    return getReplyTextConfig(params)
  }
  return []
}
